<script setup>
import Navbar from "@/partials/hardware/shop/Navbar.vue"
import AuthenticationModal from "@common/partials/installer/AuthenticationModal.vue"
import { ref } from "vue"

const dialogs = ref({
  authenticationModal: {
    toggle: false,
    mode: "sign-up",
  },
})
const toggleSignIn = () => {
  dialogs.value.authenticationModal.mode = "sign-in"
  dialogs.value.authenticationModal.toggle = true
}
const toggleSignUp = () => {
  dialogs.value.authenticationModal.mode = "sign-up"
  dialogs.value.authenticationModal.toggle = true
}
</script>

<template>
  <div>
    <Navbar @sign-in="toggleSignIn" @sign-up="toggleSignUp" />
    <main class="grow sm:py-12">
      <router-view></router-view>
    </main>
    <AuthenticationModal v-model="dialogs.authenticationModal" />
  </div>
</template>
